import axios from "axios";
import { API_URL } from "../../config/api";

class ApiService {
  constructor() {
    this.api = axios.create({
      baseURL: API_URL,
    });

    this.api.interceptors.request.use(
      (config) => {
        // Usar a mesma lógica do AuthContext
        const token = localStorage.getItem("auth_token") || localStorage.getItem("token");
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
      },
      (error) => Promise.reject(error)
    );

    // Interceptor para tratar erros de autenticação (sem redirecionar agressivamente)
    this.api.interceptors.response.use(
      (response) => response,
      (error) => {
        const status = error.response?.status;
        const url = error.config?.url || '';
        
        if (status === 401) {
          // Apenas invalidar sessão quando a checagem explícita falhar
          if (url.includes('/api/auth/me')) {
            console.log('🔒 ApiService - /auth/me retornou 401. Limpando sessão.');
            localStorage.removeItem('auth_token');
            localStorage.removeItem('token');
            localStorage.removeItem('user_data');
            if (window.location.pathname !== '/') {
              window.location.href = '/';
            }
          } else {
            // Para demais chamadas, apenas logar e repassar o erro
            console.log('⚠️ ApiService - 401 em', url, '- mantendo sessão para evitar loop.');
          }
        }
        return Promise.reject(error);
      }
    );
  }

  get(url, config = {}) {
    return this.api.get(url, config);
  }

  post(url, data, config = {}) {
    return this.api.post(url, data, config);
  }

  put(url, data, config = {}) {
    return this.api.put(url, data, config);
  }

  delete(url, config = {}) {
    return this.api.delete(url, config);
  }
}

const apiService = new ApiService();
export default apiService;
